import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { StockItem, StockAlert } from '../types/stock.types';

interface StockStore {
  stocks: StockItem[];
  alerts: StockAlert[];
  loading: boolean;
  searchTerm: string;
  selectedDeposito: number | null;

  setStocks: (stocks: StockItem[]) => void;
  setAlerts: (alerts: StockAlert[]) => void;
  setLoading: (loading: boolean) => void;
  setSearchTerm: (term: string) => void;
  setSelectedDeposito: (id: number | null) => void;
}

export const useStockStore = create<StockStore>()(
  devtools(
    (set) => ({
      stocks: [],
      alerts: [],
      loading: false,
      searchTerm: '',
      selectedDeposito: null,

      setStocks: (stocks) => set({ stocks }),
      setAlerts: (alerts) => set({ alerts }),
      setLoading: (loading) => set({ loading }),
      setSearchTerm: (searchTerm) => set({ searchTerm }),
      setSelectedDeposito: (selectedDeposito) => set({ selectedDeposito }),
    }),
    { name: 'StockStore' }
  )
);
